




































import { Vue, Component, Prop } from 'vue-property-decorator';
import UserModule from '@/store/modules/user';

@Component({
  components: {},
})
export default class UnitList extends Vue {
  @Prop() public unitUserList!: any;

  @Prop() public unitActiveId!: string;

  @Prop() public disableUnits!: boolean;

  public async onChange(item: any) {
    this.$emit('unitUserID', item.id);
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  get onBoardingUnitUser() {
    if (UserModule.currentUser && UserModule.currentRole === 'unit_manager') {
      return UserModule.currentRole;
    }
    return null;
  }
}
